module.exports = __webpack_public_path__ + "static/media/crane_logo.bf98497a.png";